
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

/** 
 * We are disabling these rules, 
 * because we DO want to add a click event on the main div of the Card
 **/

import React, { Component } from 'react';
import Slick from "react-slick";
import { map } from 'lodash';
import PT from "prop-types";
import { IconButton } from './iconbutton';
import { ResponsivenessGrid, getBreakpointForContainer, getSortedItems, RESPONSIVE_BREAKPOINTS, NBR_COLUMNS_BY_BREAKPOINTS } from './responsivenessgrid';

export class Slider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAtBeginning: true,
            isAtEnd: false,
            width: null,
            activeSlideIndex: 0,
            breakpoint: RESPONSIVE_BREAKPOINTS.large
        };

        this.sliderRef = React.createRef();
        this.setBreakpointForThisPage = this.setBreakpointForThisPage.bind(this);
    }

    componentDidMount() {
        if(this.props.breakpoint === null) {
            window.addEventListener("resize", this.setBreakpointForThisPage, false);
            this.setBreakpointForThisPage();
        }
    }


    componentWillUnmount() {
        if(this.props.breakpoint === null)
            window.removeEventListener("resize", this.setBreakpointForThisPage, false);
    }

    setBreakpointForThisPage() {
        if(this.props.breakpoint === null) { // Passe pour vérifier si c'est le slider qui se gère tout seule ou gérer à l'extérieur
            const curBreakpoint = getBreakpointForContainer(this.sliderRef, RESPONSIVE_BREAKPOINTS);

            if(this.state.breakpoint !== curBreakpoint || this.state.width !== this.sliderRef.current.clientWidth) 
                this.setState({ breakpoint: curBreakpoint, width: this.sliderRef.current.clientWidth });
        }
    }

    createItemsByGroup(items, breakpoint) {
        const allItemsGroups = getSortedItems(items, NBR_COLUMNS_BY_BREAKPOINTS[breakpoint]);

        return map(allItemsGroups,(items, index) => {
            // @ts-ignore Pourra etre enlever des qu'on est en tsx
            if((index <= this.state.activeSlideIndex) || ((index > this.state.activeSlideIndex) && this.props.display))
                return <ResponsivenessGrid key={"slider-group-" + index}
                                           width={this.state.width !== null ? this.state.width : this.props.width}
                                           currentBreakpoint={breakpoint}
                                           items={items}
                                           isSquare={true}
                                           spacingRightOnly={true}>
                </ResponsivenessGrid>;
        });
    }
    
    render() {

        const activeSlides = this.createItemsByGroup(this.props.products,(this.props.breakpoint !== null ? this.props.breakpoint : this.state.breakpoint));
        
        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            
            beforeChange: (current, next) => {
                let isAtBeginning, isAtEnd;
                if (next === 0) {
                    isAtBeginning = true;
                    isAtEnd = false;
                } else if (next >= activeSlides.length - 1) {
                    isAtBeginning = false; 
                    isAtEnd = true;
                } else {
                    isAtBeginning = false; 
                    isAtEnd = false;
                }
                
                this.setState({isAtBeginning: isAtBeginning, isAtEnd: isAtEnd});
                
                if (this.props.onDrag)
                    this.props.onDrag(true);
            },
            afterChange: (current) => {
                if (this.props.onDrag)
                    this.props.onDrag(false);
                
                this.setState({activeSlideIndex: current});
            },
            prevArrow: <SliderArrow previous={true} hide={this.state.isAtBeginning} />,
            nextArrow: <SliderArrow previous={false} hide={this.state.isAtEnd} />,
            variableWidth: true,
            className: "slider variable-width"
        };
        
        return(
            <div ref={this.sliderRef}>
                <Slick {...settings}>
                    {activeSlides}
                </Slick>
            </div>
        );
    }
}
Slider.defaultProps = {
    breakpoint: null,
    display: true
};

Slider.propTypes = {
    products: PT.array,
    breakpoint: PT.string,
    width: PT.number,
    display: PT.bool,
    onDrag: PT.func
};

function SliderArrow({hide, previous, onClick}) {
    const classNames = ["rese-slider-arrow"];
    if (previous)
        classNames.push("previous");
    else
        classNames.push("next");

    if (hide)
        classNames.push("hide");

    const icon = (previous ? "fas fa-arrow-left" : "fas fa-arrow-right");
    
    return <IconButton classNames={classNames} icon={{className: icon}} onClick={onClick} />;
}
SliderArrow.propTypes = {
    hide: PT.bool,
    previous: PT.bool,
    onClick: PT.func
};
